// src/legal/legalConfig.js
// Who operates THIS deployment, for the Terms of Service and Privacy Policy.
//
// PER INSTANCE, NEVER IN THE BASE. Each deployment is operated by someone different,
// and the base must not assert who owns any of them (NOTICE, CLAUDE.md "Provenance").
// So every identity value is a build-time env var, and an unset one renders as a
// visible [TO CONFIRM] marker rather than a plausible-looking default. A missing
// operator name on a legal page should be obvious to anyone who reads it.
//
// REACT_APP_* ARE INLINED AT BUILD TIME. Set them in Vercel before the build that
// should carry them; a redeploy reuses the old bundle (CLAUDE.md, counter-intuitive
// facts). See docs/runbook in digitalme-base for the list.

// Must equal LEGAL_VERSION in api/shared/legal.js — tests/legal-version.test.js pins it.
// It is also the "last updated" date shown on both pages.
export const LEGAL_VERSION = '2026-09-30';

export const ERASURE_DAYS = 30;

// When a user may ask for deletion: 'anytime' (default) or 'on-close'. Per instance, via
// REACT_APP_LEGAL_ERASURE. The API reads the same variable and versions the text
// accordingly (api/shared/legal.js currentLegalVersion), so changing it asks users to
// accept again.
export function erasureMode(env = process.env) {
  return (env.REACT_APP_LEGAL_ERASURE || '').trim() === 'on-close' ? 'on-close' : 'anytime';
}

function configured(value, label) {
  const v = (value || '').trim();
  return v ? { text: v, missing: false } : { text: `[${label} — TO CONFIRM]`, missing: true };
}

export function legalIdentity(env = process.env) {
  return {
    product:      configured(env.REACT_APP_PRODUCT_NAME, 'PRODUCT NAME'),
    operator:     configured(env.REACT_APP_LEGAL_OPERATOR, 'OPERATOR'),
    contactEmail: configured(env.REACT_APP_LEGAL_CONTACT_EMAIL, 'CONTACT EMAIL'),
    jurisdiction: configured(env.REACT_APP_LEGAL_JURISDICTION, 'JURISDICTION'),
  };
}

export function formatLegalDate(version = LEGAL_VERSION) {
  const d = new Date(version + 'T00:00:00Z');
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' });
}

// The two documents are addressed by URL hash so they open without signing in and
// without a router (src/App.jsx renders them ahead of AuthGate).
export const LEGAL_HASHES = { privacy: '#privacy', terms: '#terms' };

export function legalDocFromHash(hash) {
  if (hash === LEGAL_HASHES.privacy) return 'privacy';
  if (hash === LEGAL_HASHES.terms) return 'terms';
  return null;
}
